import { Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { NotificationProvider } from './contexts/NotificationContext'
import { CurrencyProvider } from './contexts/CurrencyContext'
import LandingPage from './pages/LandingPage'
import RoadmapPage from './pages/RoadmapPage'
import UpdatesPage from './pages/UpdatesPage'
import AuthPage from './pages/AuthPage'
import DashboardPage from './pages/DashboardPage'
import NewShootPage from './pages/NewShootPage'
import CalendarPage from './pages/CalendarPage'
import AddClientPage from './pages/AddClientPage'
import ClientsPage from './pages/ClientsPage'
import InvoicesPage from './pages/InvoicesPage'
import CreateInvoicePage from './pages/CreateInvoicePage'
import InvoiceViewPage from './pages/InvoiceViewPage'
import InvoiceEditPage from './pages/InvoiceEditPage'
import UploadedInvoiceViewPage from './pages/UploadedInvoiceViewPage'
import TasksPage from './pages/TasksPage'
import UpgradePage from './pages/UpgradePage'
import CheckoutPage from './pages/CheckoutPage'
import CheckoutSuccessPage from './pages/CheckoutSuccessPage'
import ProfilePage from './pages/ProfilePage'
import NotificationHistoryPage from './pages/NotificationHistoryPage'
import AdminBugReportsPage from './pages/AdminBugReportsPage'
import AdminDashboardPage from './pages/AdminDashboardPage'
import AdminUsersPage from './pages/AdminUsersPage'
import AdminAnalyticsPage from './pages/AdminAnalyticsPage'
import AdminSystemSettingsPage from './pages/AdminSystemSettingsPage'
import AdminContentManagementPage from './pages/AdminContentManagementPage'
import AdminSecurityAuditPage from './pages/AdminSecurityAuditPage'
import AdminNotificationsPage from './pages/AdminNotificationsPage'
import AdminWaitlistPage from './pages/AdminWaitlistPage'
import ProtectedRoute from './components/ProtectedRoute'
import ProtectedAdminRoute from './components/ProtectedAdminRoute'
import ProtectedClientRoute from './components/ProtectedClientRoute'
import LaunchGate from './components/LaunchGate'
import SupabaseDebug from './components/SupabaseDebug'
import SessionWarning from './components/SessionWarning'
import SubscriptionStatusMonitor from './components/SubscriptionStatusMonitor'
import BusinessAnalyticsPage from './pages/BusinessAnalyticsPage'
import BrandingPage from './pages/BrandingPage'
import ProjectTemplatesPage from './pages/ProjectTemplatesPage'
import ProjectsPage from './pages/ProjectsPage'
import DocumentsPage from './pages/DocumentsPage'
import CreateDocumentPage from './pages/CreateDocumentPage'
import DocumentViewPage from './pages/DocumentViewPage'
import EditDocumentPage from './pages/EditDocumentPage'
import ClientAuthPage from './pages/client/ClientAuthPage'
import ClientDashboardPage from './pages/client/DashboardPage'
import ClientProfilePage from './pages/client/ProfilePage'
import ClientPortalsPage from './pages/ClientPortalsPage'

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <CurrencyProvider>
          <div className="min-h-screen">
        <Routes>
          {/* Public routes that bypass launch gate */}
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/client/auth" element={<ClientAuthPage />} />
          <Route path="/debug" element={<SupabaseDebug />} />
          
          {/* Main app routes wrapped in LaunchGate */}
          <Route path="/*" element={
            <LaunchGate>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/roadmap" element={<RoadmapPage />} />
                <Route path="/updates" element={<UpdatesPage />} />
                
                {/* Client Portal Routes */}
                <Route path="/client/*" element={
                  <ProtectedClientRoute>
                    <Routes>
                      <Route path="/" element={<ClientDashboardPage />} />
                      <Route path="/profile" element={<ClientProfilePage />} />
                    </Routes>
                  </ProtectedClientRoute>
                } />

                <Route 
                  path="/dashboard" 
                  element={
                    <ProtectedRoute>
                      <DashboardPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/new-shoot" 
                  element={
                    <ProtectedRoute>
                      <NewShootPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/calendar" 
                  element={
                    <ProtectedRoute>
                      <CalendarPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/add-client" 
                  element={
                    <ProtectedRoute>
                      <AddClientPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/clients" 
                  element={
                    <ProtectedRoute>
                      <ClientsPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/invoices" 
                  element={
                    <ProtectedRoute>
                      <InvoicesPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/invoices/new" 
                  element={
                    <ProtectedRoute>
                      <CreateInvoicePage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/invoices/:id" 
                  element={
                    <ProtectedRoute>
                      <InvoiceViewPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/invoices/:id/edit" 
                  element={
                    <ProtectedRoute>
                      <InvoiceEditPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/invoices/uploaded/:id" 
                  element={
                    <ProtectedRoute>
                      <UploadedInvoiceViewPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/tasks" 
                  element={
                    <ProtectedRoute>
                      <TasksPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/upgrade" 
                  element={
                    <ProtectedRoute>
                      <UpgradePage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/checkout" 
                  element={
                    <ProtectedRoute>
                      <CheckoutPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/checkout/success" 
                  element={
                    <ProtectedRoute>
                      <CheckoutSuccessPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/profile" 
                  element={
                    <ProtectedRoute>
                      <ProfilePage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/notifications" 
                  element={
                    <ProtectedRoute>
                      <NotificationHistoryPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin" 
                  element={
                    <ProtectedAdminRoute>
                      <AdminDashboardPage />
                    </ProtectedAdminRoute>
                  } 
                />
                <Route 
                  path="/admin/users" 
                  element={
                    <ProtectedAdminRoute>
                      <AdminUsersPage />
                    </ProtectedAdminRoute>
                  } 
                />
                <Route 
                  path="/admin/analytics" 
                  element={
                    <ProtectedAdminRoute>
                      <AdminAnalyticsPage />
                    </ProtectedAdminRoute>
                  } 
                />
                <Route 
                  path="/admin/bug-reports" 
                  element={
                    <ProtectedAdminRoute>
                      <AdminBugReportsPage />
                    </ProtectedAdminRoute>
                  } 
                />
                <Route 
                  path="/admin/waitlist" 
                  element={
                    <ProtectedAdminRoute>
                      <AdminWaitlistPage />
                    </ProtectedAdminRoute>
                  } 
                />
                <Route 
                  path="/admin/settings" 
                  element={
                    <ProtectedAdminRoute>
                      <AdminSystemSettingsPage />
                    </ProtectedAdminRoute>
                  } 
                />
                <Route 
                  path="/admin/content" 
                  element={
                    <ProtectedAdminRoute>
                      <AdminContentManagementPage />
                    </ProtectedAdminRoute>
                  } 
                />
                <Route 
                  path="/admin/security" 
                  element={
                    <ProtectedAdminRoute>
                      <AdminSecurityAuditPage />
                    </ProtectedAdminRoute>
                  } 
                />
                <Route 
                  path="/admin/notifications" 
                  element={
                    <ProtectedAdminRoute>
                      <AdminNotificationsPage />
                    </ProtectedAdminRoute>
                  } 
                />
                <Route 
                  path="/business-analytics" 
                  element={
                    <ProtectedRoute>
                      <BusinessAnalyticsPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/branding" 
                  element={
                    <ProtectedRoute>
                      <BrandingPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/project-templates" 
                  element={
                    <ProtectedRoute>
                      <ProjectTemplatesPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/projects" 
                  element={
                    <ProtectedRoute>
                      <ProjectsPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/documents" 
                  element={
                    <ProtectedRoute>
                      <DocumentsPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/documents/new" 
                  element={
                    <ProtectedRoute>
                      <CreateDocumentPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/documents/:id" 
                  element={
                    <ProtectedRoute>
                      <DocumentViewPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/documents/:id/edit" 
                  element={
                    <ProtectedRoute>
                      <EditDocumentPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/client-portals" 
                  element={
                    <ProtectedRoute>
                      <ClientPortalsPage />
                    </ProtectedRoute>
                  } 
                />
              </Routes>
            </LaunchGate>
          } />
        </Routes>
        
        {/* Global session warning modal */}
        <SessionWarning />
        
        {/* Subscription status monitor for debugging (development only) */}
        <SubscriptionStatusMonitor enabled={process.env.NODE_ENV === 'development'} />
          </div>
        </CurrencyProvider>
      </NotificationProvider>
    </AuthProvider>
  )
}

export default App 